"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferStore = void 0;
var mobx_1 = require("mobx");
var offerApi_1 = __importDefault(require("../api/offerApi"));
var i18n_1 = __importDefault(require("../i18n"));
var createSessionId = function () {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return "session-".concat(Date.now(), "-").concat(Math.floor(Math.random() * 1000000));
};
var OfferStore = /** @class */ (function () {
    function OfferStore() {
        Object.defineProperty(this, "sessionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "currentOrderId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "currentPaymentUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "offers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "selectedOffers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "purchaseStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "errorMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "isLoadingOffers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isPurchasing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        (0, mobx_1.makeObservable)(this, {
            sessionId: mobx_1.observable,
            currentOrderId: mobx_1.observable,
            currentPaymentUrl: mobx_1.observable,
            offers: mobx_1.observable,
            selectedOffers: mobx_1.observable,
            purchaseStatus: mobx_1.observable,
            errorMessage: mobx_1.observable,
            isLoadingOffers: mobx_1.observable,
            isPurchasing: mobx_1.observable,
            initializeSessionAndLoadOffers: mobx_1.action.bound,
            toggleCartSelection: mobx_1.action.bound,
            syncPurchaseStatus: mobx_1.action.bound,
            clearPurchaseStatus: mobx_1.action.bound,
            clearError: mobx_1.action.bound
        });
    }
    Object.defineProperty(OfferStore.prototype, "initializeSessionAndLoadOffers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var response_1, error_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.sessionId) {
                                this.sessionId = createSessionId();
                            }
                            if (this.offers.length > 0) {
                                return [2 /*return*/];
                            }
                            this.isLoadingOffers = true;
                            this.errorMessage = null;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, offerApi_1.default.getOffers(this.sessionId)];
                        case 2:
                            response_1 = _a.sent();
                            (0, mobx_1.runInAction)(function () {
                                _this.offers = response_1.offers;
                            });
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _a.sent();
                            (0, mobx_1.runInAction)(function () {
                                _this.errorMessage =
                                    error_1 instanceof Error
                                        ? error_1.message
                                        : i18n_1.default.t("OFFER_ERROR_LOAD_OFFERS");
                            });
                            return [3 /*break*/, 5];
                        case 4:
                            (0, mobx_1.runInAction)(function () {
                                _this.isLoadingOffers = false;
                            });
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OfferStore.prototype, "toggleCartSelection", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offer) {
            var _a;
            if (offer.isDisabled || this.isEnded(offer) || ((_a = offer.remainingSeats) !== null && _a !== void 0 ? _a : 0) <= 0) {
                return;
            }
            var exists = this.selectedOffers.some(function (item) { return item.id === offer.id; });
            if (exists) {
                this.selectedOffers = this.selectedOffers.filter(function (item) { return item.id !== offer.id; });
                return;
            }
            this.selectedOffers = __spreadArray(__spreadArray([], this.selectedOffers, true), [offer], false);
        }
    });
    Object.defineProperty(OfferStore.prototype, "isSelected", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offerId) {
            return this.selectedOffers.some(function (item) { return item.id === offerId; });
        }
    });
    Object.defineProperty(OfferStore.prototype, "purchaseSelectedOffers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offers) {
            return __awaiter(this, void 0, void 0, function () {
                var purchasableOffers, response_2, error_2;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            purchasableOffers = offers.filter(function (offer) { var _a; return !offer.isDisabled && !_this.isEnded(offer) && ((_a = offer.remainingSeats) !== null && _a !== void 0 ? _a : 0) > 0; });
                            if (purchasableOffers.length === 0) {
                                this.purchaseStatus = "failed";
                                return [2 /*return*/, { status: "failed" }];
                            }
                            this.isPurchasing = true;
                            this.errorMessage = null;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, offerApi_1.default.purchaseOffers({
                                    selectedOffers: purchasableOffers
                                }, this.sessionId)];
                        case 2:
                            response_2 = _a.sent();
                            (0, mobx_1.runInAction)(function () {
                                _this.currentOrderId = response_2.orderId || "";
                                _this.currentPaymentUrl = response_2.paymentUrl || "";
                                _this.purchaseStatus = response_2.status;
                                if (response_2.status === "success") {
                                    var purchasedIds_1 = new Set(purchasableOffers.map(function (item) { return item.id; }));
                                    _this.selectedOffers = _this.selectedOffers.filter(function (item) { return !purchasedIds_1.has(item.id); });
                                    if (typeof sessionStorage !== "undefined") {
                                        sessionStorage.setItem("pos.purchase.".concat(_this.sessionId), JSON.stringify(response_2.tickets || []));
                                    }
                                }
                            });
                            return [2 /*return*/, response_2];
                        case 3:
                            error_2 = _a.sent();
                            (0, mobx_1.runInAction)(function () {
                                _this.purchaseStatus = "failed";
                                _this.errorMessage =
                                    error_2 instanceof Error
                                        ? error_2.message
                                        : i18n_1.default.t("OFFER_ERROR_COMPLETE_PURCHASE");
                            });
                            return [2 /*return*/, { status: "failed" }];
                        case 4:
                            (0, mobx_1.runInAction)(function () {
                                _this.isPurchasing = false;
                            });
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OfferStore.prototype, "isEnded", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offer) {
            return Boolean(offer.endedAt && Date.parse(offer.endedAt) <= Date.now());
        }
    });
    Object.defineProperty(OfferStore.prototype, "syncPurchaseStatus", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (orderId) {
            return __awaiter(this, void 0, void 0, function () {
                var response_3, error_3;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, offerApi_1.default.getPurchaseStatus(orderId, this.sessionId)];
                        case 1:
                            response_3 = _a.sent();
                            (0, mobx_1.runInAction)(function () {
                                _this.purchaseStatus = response_3.status;
                                if (response_3.status === "success") {
                                    if (typeof sessionStorage !== "undefined") {
                                        sessionStorage.setItem("pos.purchase.".concat(_this.sessionId), JSON.stringify(response_3.tickets || []));
                                    }
                                }
                            });
                            return [2 /*return*/, response_3];
                        case 2:
                            error_3 = _a.sent();
                            (0, mobx_1.runInAction)(function () {
                                _this.purchaseStatus = "failed";
                                _this.errorMessage =
                                    error_3 instanceof Error
                                        ? error_3.message
                                        : i18n_1.default.t("OFFER_ERROR_CONFIRM_PURCHASE");
                            });
                            return [2 /*return*/, { status: "failed" }];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OfferStore.prototype, "clearPurchaseStatus", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.purchaseStatus = null;
            this.currentOrderId = "";
            this.currentPaymentUrl = "";
        }
    });
    Object.defineProperty(OfferStore.prototype, "clearError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.errorMessage = null;
        }
    });
    return OfferStore;
}());
exports.OfferStore = OfferStore;
exports.default = new OfferStore();
